import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { BandejaRevisionDocumentalPage } from "@/features/revision-documental/components/BandejaRevisionDocumentalPage";
import { bandejaRevisionQueryOptions } from "@/features/revision-documental/hooks/use-revision-documental";

/**
 * Ruta `/revision-documental` · bandeja de los REVISORES documentales (por los roles configurados
 * en cada categoría/tipo · sin permiso fijo). Quien no revisa nada ve «Acceso restringido».
 */
export const Route = createFileRoute("/_authed-tw/revision-documental")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(bandejaRevisionQueryOptions({ page: 1, pageSize: 15 })),
  component: BandejaRevisionDocumentalPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
